import { ElementType } from 'react';

import { EnglishIcon, FrenchIcon, GermanIcon, SpanishIcon, SwedishIcon } from '@/assets/icons';

export enum LanguageCode {
  EN = 'en',
  FR = 'fr',
  DE = 'de',
  ES = 'es',
  SV = 'sv',
}

export enum Localization {
  EN = 'LOCALIZATION_EN',
  FR = 'LOCALIZATION_FR',
  DE = 'LOCALIZATION_DE',
  ES = 'LOCALIZATION_ES',
  SV = 'LOCALIZATION_SV',
}

export const LanguageCodeMap: Record<LanguageCode, string> = {
  [LanguageCode.EN]: Localization.EN,
  [LanguageCode.FR]: Localization.FR,
  [LanguageCode.DE]: Localization.DE,
  [LanguageCode.ES]: Localization.ES,
  [LanguageCode.SV]: Localization.SV,
};

export const LanguageNameMap: Record<LanguageCode, { name: string; icon: ElementType }> = {
  [LanguageCode.EN]: { name: 'English', icon: EnglishIcon },
  [LanguageCode.FR]: { name: 'French', icon: FrenchIcon },
  [LanguageCode.DE]: { name: 'German', icon: GermanIcon },
  [LanguageCode.ES]: { name: 'Spanish', icon: SpanishIcon },
  [LanguageCode.SV]: { name: 'Swedish', icon: SwedishIcon },
};

export const LanguageOptions = Object.entries(LanguageNameMap).map(([key, value]) => ({
  value: key as LanguageCode,
  label: value,
}));
